/*
 * @Author: Teemo Ding
 * @Date: 2022-03-01 15:37:13
 * @LastEditTime: 2022-06-10 08:58:24
 * @LastEditors: Json Chen
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCommunication/CommunicationGateways/index.tsx
 */
import Table from '@/src/components/Antd/Table/SizeFittingTable';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import { Button } from 'antd';
import React from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import { communicationColumns } from '../config';
import css from '../css.module.less';

const CommunicationGateways = ({
  data,
  onSelectCommunicationGateway,
  deleteFun,
  disableDelete,
  disableEdit,
}) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  return (
    <SectionWrapper
      titleClassName={css.titleContainer}
      containerClassName={css.containerClassName}
      title={getI18n('salesChannelCommunication.index.communicationGateways')}>
      <Table
        id='communicationGateways'
        rowKey='channelType'
        className={css.globalStoreTable}
        columns={communicationColumns(deleteFun, disableDelete, { getI18n })}
        dataSource={data}
        pagination={false}
      />
      <Button
        type='primary'
        onClick={() => onSelectCommunicationGateway()}
        className={css.selectedBtn}
        disabled={disableEdit}>
        {getI18n('salesChannelCommunication.index.selectcommunicationgateways')}
      </Button>
    </SectionWrapper>
  );
};

export default CommunicationGateways;
